export default {
  enterprise: {
    title: "法人",
  },
  login: {
    title: "ログイン",
    user_id: "ユーザーID",
    password: "パスワード",
    enterprise: {
      title: "法人ログイン",
      id: "法人ID",
      remember_me: "ログイン状態を維持する",
      remember_ids: "法人ID、ユーザーIDを記憶する",
      forget_password:
        "パスワードをお忘れの方は、担当者へお問い合わせください。",
    },
  },
  SideMenu: {
    Dashboard: "ダッシュボード",
    Tool: "ツール",
    Management: "管理",
    Plots: "プロット",
    PrivatePlots: "プライベートプロット",
    Maps: "マップ",
    VoyageHistories: "航海記録",
    Logout: "ログアウト",
    Enterprise: {
      Users: "社員管理",
      Crews: "労務管理",
      Vessels: "船舶管理",
      Destinations: "目的地管理",
      Camera: "カメラ管理",
      Notification: "お知らせ",
      VesselMonitoringEngine: "機関データ",
      Addons: {
        PortManagement: "入出港管理",
        PortMaster: "Port Master",
        GkmgPortMaster: "Port Master C",
      },
    },
  },
  Views: {
    Commons: {
      DataTime: "日時",
    },
    Vessel: {
      Info: "船舶情報",
      AisTitle: "AIS情報",
      SizeTitle: "サイズ情報",
      Name: "船名(英)",
      NameJa: "船名",
      Category: "船種",
      Country: "国籍",
      CertificateNumber: "船舶番号",
      IdentificationNumber: "識別番号",
      GrossTonnage: "総トン数",
      LengthOverall: "全長",
      Width: "全幅",
      Draft: "喫水",
      FullDraft: "満載喫水",
      Status: "運航状態",
      LastReceived: "最終受信",
      Heading: "方位",
      Direction: "方位",
      Velocity: "速力",
      Latitude: "緯度",
      Longitude: "経度",
      Geo: "緯度経度",
      IMO: "IMO",
      MMSI: "MMSI",
      CallSign: "Call Sign",
      DimBow: "DimBow",
      DimStern: "DimStern",
      DimStarboard: "DimStarboard",
      DimPort: "DimPort",
      Destination: "目的地",
      ETA: "ETA",
      WakeLine: "航跡",
      TrackimoId: "ID",
      Kinds: "種別",
      Battery: "バッテリー",
    },
    Crew: {
      captain: "船長",
      chief_officer: "一等航海士",
      second_officer: "二等航海士",
      third_officer: "三等航海士",
      boatswain: "甲板長",
      able_seaman: "甲板手",
      ordinary_seaman: "甲板員",
      chief_engineer: "機関長",
      first_engineer: "一等機関士",
      second_engineer: "二等機関士",
      third_engineer: "三等機関士",
      machinist: "操機長",
      oiler: "操機手",
      wiper: "機関員",
      chief_radio_operator: "通信長",
      purser: "事務長",
      clerk: "事務員",
      chief_steward: "司厨長",
      steward: "司厨手",
      messman: "司厨員",
      chief_cook: "調理士",
      second_cook: "調理員",
      doctor: "船医",
      nurse: "看護師",
      other: "その他",

      "Ro-Ro Ship": "RORO船",
      "Oil Tanker": "油送船",
      "General Cargo": "一般貨物船",
      "Container Ship": "コンテナ船",
      "Chemical Tanker": "ケミカル船",
      PCC: "自動車専用船",
      "LPG Tanker": "LPG船",
      "LNG Tanker": "LNG船",
      "Cement Tanker": "セメント専用船",
      "Passenger Ship": "旅客船",
      "Pusher Barge": "プッシャーバージ",
      "Limestone Carrier": "石灰石専用船",
      Tug: "タグボート",
      "Other type": "その他",
      Drillship: "海底掘削船",
      "Seabed Explorer": "海洋資源探査船",
      LaborRecord: {
        Tasks: {
          on_duty: "当直",
          take_over_on_duty: "当直引継",
          cargo_handling: "荷役",
          departure_and_arrival: "出入港",
          maintenance: "保守",
          work_while_moored: "停泊中作業",
          food_service: "供食",
          emergency_station_drill: "操練等",
          training: "研修",
          safe_temporary_work: "安全臨時労働",
          urgent_work: "緊急作業（人命救助等）",
          others: "その他（事務等）",
        },
      },
    },
  },

  // PageじゃなくViews配下に追加してね ＊削除予定
  Page: {
    PlaceHolder: {
      Search: "検索",
    },
    Vessel: {
      VesselTitle: "船舶情報",
      AisTitle: "AIS情報",
      SizeTitle: "サイズ情報",
      Name: "名前",
      NameJa: "名前",
      Category: "船種",
      Country: "国籍",
      CertificateNumber: "船舶番号/漁船登録番号",
      IdentificationNumber: "船体識別番号",
      Status: "状態",
      ReceivedTime: "受信日時",
      Heading: "船首",
      Direction: "方位",
      Velocity: "速度",
      Latitude: "緯度",
      Longitude: "経度",
      Geo: "緯度経度",
      Imo: "IMO",
      Mmsi: "MMSI",
      CallSign: "Call Sign",
      LengthOverall: "全長",
      Width: "横幅",
      DimBow: "DimBow",
      DimStern: "DimStern",
      DimStarboard: "DimStarboard",
      DimPort: "DimPort",
      FullDraft: "満載喫水",
    },
    Search: "検索",
  },
};
